import { render, staticRenderFns } from "./DeliveredTheOrder.vue?vue&type=template&id=340d5ee2&scoped=true&"
import script from "./DeliveredTheOrder.vue?vue&type=script&lang=js&"
export * from "./DeliveredTheOrder.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredTheOrder.vue?vue&type=style&index=0&id=340d5ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340d5ee2",
  null
  
)

export default component.exports